export default __webpack_public_path__ + "static/media/ai.fef05077.png";